var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ai-chat-win-wrapper"
  }, [_c("ai-greeting", {
    staticClass: "m-t-36",
    attrs: {
      text: "欢迎使用税启家法规库系统！您的问题交给我，我将为您答疑解惑"
    }
  }), _c("div", {
    staticClass: "divider m-t-16"
  }, [_c("van-divider", [_c("svg-icon", {
    attrs: {
      name: "ellipsis"
    }
  })], 1)], 1), _vm._l(_vm.aiChatList, function (chat, index) {
    return _c("div", {
      key: index,
      staticClass: "ai-chat-message-row m-t-16"
    }, [chat.question.content ? _c("question-box", {
      attrs: {
        message: chat.question.content
      }
    }) : _vm._e(), chat.answer ? _c("answer-box", {
      attrs: {
        answer: chat.answer,
        question: chat.question
      }
    }) : _vm._e()], 1);
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };